import { render, staticRenderFns } from "./ShowAdminOrganisation.vue?vue&type=template&id=ba11d850&scoped=true&"
import script from "./ShowAdminOrganisation.vue?vue&type=script&lang=js&"
export * from "./ShowAdminOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba11d850",
  null
  
)

export default component.exports